export type CartAbandonmentState = {
  itemCount: number;
  sent: boolean;
  checkoutInitiated: boolean;
};

export function cartItemCount(items: Array<{ quantity: number }>): number {
  return items.reduce((total, item) => total + Math.max(0, Number(item.quantity) || 0), 0);
}

export function canTrackCartAbandoned(state: CartAbandonmentState): boolean {
  return state.itemCount > 0 && !state.sent && !state.checkoutInitiated;
}
